<template>
  <page>
    <div>
      <!-- Add Filters here -->
      <v-flex xs12>
        <form action="">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="stdrisktxt"
                            v-model="filter.stdRiskTxtRef"
                            :label="label.stdRiskTxtRef"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stdRiskTxtRef"
                            :data-vv-as="label.stdRiskTxtRef"
                            :error-messages="errors.collect('stdRiskTxtRef')"
                            @input="doGetItemByRisk($event)"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="stdriskitemtxt"
                            v-model="filter.stdItemTxtRef"
                            :label="label.stdItemTxtRef"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stdItemTxtRef"
                            :data-vv-as="label.stdItemTxtRef"
                            :error-messages="errors.collect('stdItemTxtRef')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <v-autocomplete
                            :items="benefit"
                            v-model="filter.benefit"
                            :label="label.benefit"
                            item-text="label"
                            item-value="value"
                            data-vv-name="benefit"
                            :data-vv-as="label.benefit"
                            :error-messages="errors.collect('benefit')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-1"></v-spacer>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNew">
            New Default Benefit
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
        </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.stdRiskTxtRef }}</td>
                  <td class="text-xs-left">{{ row.item.stdItemTxtRef }}</td>
                  <td class="text-xs-left">{{ row.item.benefit }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" query @query="doQuery(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                  </td></tr
              ></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
      <confirm v-model="promptRemove" @ok="doDelete">
        <p>Are you sure you want to delete the selected Standard Item Default Benefit?</p>
        <div class="queryValue">
          Standard Risk Text Reference: {{ selected.stdRiskTxtRef }}<br />
          Standard Item Text Reference: {{ selected.stdItemTxtRef }}<br />
          Benefit: {{ selected.benefit }}
        </div>
      </confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      toogleArray: [false],
      benefit: [],
      stdrisktxt: [],
      stdriskitemtxt: [],
      items: [],
      label: {
        stdRiskTxtRef: 'Standard Risk Text Reference',
        stdItemTxtRef: 'Standard Item Text Reference',
        benefit: 'Benefit'
      },
      filter: {
        stdRiskTxtRef: null,
        stdItemTxtRef: null,
        benefit: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Risk Text Reference', align: 'left', value: 'stdRiskTxtRef' },
        { text: 'Item Text Reference', align: 'left', value: 'stdItemTxtRef' },
        { text: 'Benefit', align: 'left', value: 'benefit' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selected: {
        stdRiskTxtRef: null,
        stdItemTxtRef: null,
        benefit: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  async mounted() {
    this.fetchData(true)
    this.doInit()
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataListDropDown('stdrisktxt')
      this.getCommonDataListDropDown('benefit')
      this.fetchData(true)
      this.fetchStdRiskItemTxt()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.getStdItemTxtDefBenList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((datamap) => {
                const convertList = {
                  stdRiskTxtRef: datamap.stdRiskTxtRef,
                  stdItemTxtRef: datamap.stdItemTxtRef,
                  benefit: datamap.benefit
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async fetchStdRiskItemTxt() {
      const apiUrl = this.menu.stdRiskItemTxtList
      if (apiUrl) {
        try {
          this.stdriskitemtxt = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'stdriskitemtxt', result.data.dataList)
          }
        } catch (err) {
          this.stdriskitemtxt = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doNew() {
      const commit = {
        tranMode: 'New',
        stdRiskTxtRef: null,
        stdItemTxtRef: null,
        benefit: null
      }
      sessionStorage.setItem('stdItemTxtDefBen', JSON.stringify(commit))
      this.$store.commit('STD_ITEM_TXT_DEF_BEN_COMMIT_KEY', commit)
      this.$router.push({ name: 'stdItemTxtDefBenReview' })
    },
    doQuery(data) {
      const commit = {
        tranMode: 'Query',
        stdRiskTxtRef: data.stdRiskTxtRef,
        stdItemTxtRef: data.stdItemTxtRef,
        benefit: data.benefit
      }
      sessionStorage.setItem('stdItemTxtDefBen', JSON.stringify(commit))
      this.$store.commit('STD_ITEM_TXT_DEF_BEN_COMMIT_KEY', commit)
      this.$router.push({ name: 'stdItemTxtDefBenReview' })
    },
    doPromptRemove(data) {
      if (data) {
        this.selected.stdRiskTxtRef = data.stdRiskTxtRef
        this.selected.stdItemTxtRef = data.stdItemTxtRef
        this.selected.benefit = data.benefit
        this.promptRemove = true
      }
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.stdRiskTxtRef) {
        const apiURI = this.menu.deleteStdItemTxtDefBen
        if (apiURI) {
          const expand = {
            stdRiskTxtRef: this.selected.stdRiskTxtRef,
            stdItemTxtRef: this.selected.stdItemTxtRef,
            benefit: this.selected.benefit
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.fetchData(false)
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.stdRiskTxtRef = undefined
      this.filter.stdItemTxtRef = undefined
      this.filter.benefit = undefined
      this.fetchData(false)
    },
    doGetItemByRisk(event) {
      if (this.filter.stdRiskTxtRef !== '') {
        this.stdriskitemtxt = []
        const apiURI = this.menu.getStdRiskItemTxtListByStdRiskTxt
        if (apiURI) {
          const expand = {
            stdRiskTxtRef: this.filter.stdRiskTxtRef
          }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((results) => {
              if (results.data.dataList) {
                this.$set(this, 'stdriskitemtxt', results.data.dataList)
              } else {
                this.filter.stdItemTxtRef = ''
                this.fetchStdRiskItemTxt()
              }
            })
            .catch((err) => {
              this.stdriskitemtxt = []
              const { data } = err.response
              if (data) {
                this.fieldMessage(data)
                this.notify(data)
              }
            })
        }
      } else {
        this.filter.stdItemTxtRef = ''
        this.fetchStdRiskItemTxt()
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.stdItemTxtDefBenParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
